module.exports = __webpack_public_path__ + "img/enter_grey.03d4dc6b.svg";